module.exports = __webpack_public_path__ + "static/media/footer-layout-3.bd59a4ab.svg";